// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html {
  -webkit-text-size-adjust: 100%;
  overflow-x: hidden;
}

body {
  font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  overflow-x: hidden;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace;
}

#root {
  overflow-x: hidden;
  width: 100%;
}

/* Touch-friendly tap targets */
@media (pointer: coarse) {
  button,
  [role="button"],
  .MuiIconButton-root,
  .MuiMenuItem-root,
  .MuiListItem-root {
    min-height: 44px;
    min-width: 44px;
  }
  .MuiChip-root {
    height: 32px;
  }
}

/* Mobile dialog sizing */
@media (max-width: 600px) {
  .MuiDialog-paper {
    margin: 16px;
    width: calc(100% - 32px) !important;
    max-width: calc(100% - 32px) !important;
  }
  .MuiTableContainer-root {
    -webkit-overflow-scrolling: touch;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,uDAAuD;EACvD,mCAAmC;EACnC,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,+EAA+E;AACjF;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA,+BAA+B;AAC/B;EACE;;;;;IAKE,gBAAgB;IAChB,eAAe;EACjB;EACA;IACE,YAAY;EACd;AACF;;AAEA,yBAAyB;AACzB;EACE;IACE,YAAY;IACZ,mCAAmC;IACnC,uCAAuC;EACzC;EACA;IACE,iCAAiC;EACnC;AACF","sourcesContent":["* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nhtml {\n  -webkit-text-size-adjust: 100%;\n  overflow-x: hidden;\n}\n\nbody {\n  font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  overflow-x: hidden;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace;\n}\n\n#root {\n  overflow-x: hidden;\n  width: 100%;\n}\n\n/* Touch-friendly tap targets */\n@media (pointer: coarse) {\n  button,\n  [role=\"button\"],\n  .MuiIconButton-root,\n  .MuiMenuItem-root,\n  .MuiListItem-root {\n    min-height: 44px;\n    min-width: 44px;\n  }\n  .MuiChip-root {\n    height: 32px;\n  }\n}\n\n/* Mobile dialog sizing */\n@media (max-width: 600px) {\n  .MuiDialog-paper {\n    margin: 16px;\n    width: calc(100% - 32px) !important;\n    max-width: calc(100% - 32px) !important;\n  }\n  .MuiTableContainer-root {\n    -webkit-overflow-scrolling: touch;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
